import { createContext, useContext } from 'react';
import { User } from 'firebase/auth';

// Define the shape of our Firebase context
export interface FirebaseContextType {
  isAuthenticated?: boolean;
  isInitialized: boolean;
  isLoading: boolean;
  user?: User | null;
  error?: string | null;
  networkStatus?: Record<string, any>;
  checkFirebaseConnectivity?: () => Promise<boolean>;
  checkConnectivity?: () => Promise<boolean>;
  resetFlags?: () => void;
}

// Create the context with default values
export const FirebaseContext = createContext<FirebaseContextType>({
  isAuthenticated: false,
  isInitialized: false,
  isLoading: false,
  user: null,
  error: null,
  networkStatus: {},
  checkFirebaseConnectivity: async () => false,
  checkConnectivity: async () => false,
  resetFlags: () => {}
});

// Custom hook to use the Firebase context
export const useFirebase = () => useContext(FirebaseContext);

export default FirebaseContext;